module.exports = __webpack_public_path__ + "static/media/8.10b775cc.jpeg";